<!--
 * @Author: Merlin
 * @Date: 2024-03-26 19:15:19
 * @LastEditors: Merlin
 * @LastEditTime: 2024-04-29 19:32:23
 * @Description: 这个组件用于单向显示卡牌，没有用户交互事件
-->

<template>
    <figure ref="card" class="card" >
        <div class="card-ins animetecard"
            v-if="oCardStyle"
            :style="oCardStyle"
        >
            <img class="imgs"
                :src="cardImages[card.cardID || cardName]"
                style="transform: rotateY(180deg)"
            />
            <!-- ↑ 卡片的正面 --> 
            <!-- ↓ 卡片背面-->
            <img class="imgs" :src="cardImages['card_close']" />
            <!-- ↓ -->
            <div class="card-ins2"
                :style="{ borderColor: borderStyle, borderRadius: '6.3px' }"
            ></div>
        </div>
    </figure>
</template>

<script lang="ts">
import type { CardInterface } from '../ts/blackjackGame';

const animateConfig = {
    cardMoveDelay: 500,
    cardRotateDelay: 200,
    cardMoveDelayNoAnimate: 5,
};

export default defineComponent({
    props: {
        cardName: {
            type: String,
            required: true,
        },
        card: {
            type: Object as PropType<CardInterface>,
            default: ()=>({}),
            // required: true,
        },
        status: {
            type: String,
            // required: true,
        },
        animation: {
            type: Boolean,
            // required: true,
        },
    },
    data() {
        const cardImagesNuxtLink = import.meta.glob('../img/cards/*', { eager: true });
        const cardImagesList = Object.entries(cardImagesNuxtLink).map(([key, value]) => {
            const cardName = key.replace('../img/cards/', '').replace('.png', '');
            return [cardName, (value as { default: any }).default];
        });
        // ↓ 卡片图列表
        const cardImages = Object.fromEntries(cardImagesList);
        return {
            cardImages,
            angle: 0,
            oCardStyle: null, // 样式对象
        };
    },
    computed: {
        borderStyle() {
            switch (this.status) {
                case 'win':
                    return '#1BB83DFF';
                case 'lose':
                    return '#ED1D49FF';
                case 'bust':
                    return '#ED1D49FF';
                case 'equal':
                    return '#FFB636';
                case 'split':
                    return '#2283F6';
                case 'play':
                    return '#FFFFFF';
                default:
                    return '#FFFFFF';
            }
        },
    },
    watch: {
        'card.cardID': {
            deep: true,
            handler(cardNew, cardOld){
                // console.log(cardOld, '=>', cardNew); 
                if (cardOld === 'card_close'){
                    this.setCardStyle(true);
                }
            },
        },
    },
    created(){
        if (import.meta.server) return;
        this.setCardStyle();
        // ↓ 显示牌面
        setTimeout(() => {
            this.setCardStyle(true);
        }, animateConfig.cardRotateDelay);
    },
    mounted() {
        this.animateElement();
    },
    methods: {
        // ↓ 动画：移动卡片位置 
        animateElement() {
            // console.log("this.card.goFast", this.card.goFast); 
            if (!this.animation || this.card.goFast) {
                return;
            }
            const deckCont = document.getElementById('tableDeck');
            const { left: deckLeft, top: deckTop } = deckCont.getBoundingClientRect();
            const { left: elementLeft, top: elementTop } = (
                this.$refs.card as HTMLElement
            ).getBoundingClientRect();
            const offsetX = deckLeft - elementLeft; 
            const offsetY = deckTop - elementTop; 
            const translateFrom = `translate(${offsetX}px, ${offsetY}px)`;
            const translateTo = 'translate(0, 0)';
            (this.$refs.card as HTMLElement).style.zIndex = '1';
            const aAnimationStep = [
                { transform: translateFrom }, // 初始位置 
                { transform: translateTo }, // 目标位置 
            ];
            (this.$refs.card as HTMLElement).animate(
                aAnimationStep,
                {
                    duration: true ? animateConfig.cardMoveDelay : 5,
                    easing: 'cubic-bezier(0.16, 0.95, 0.3, 0.94)',
                },
            );
            // this.onStartAnimation = false;
        },
        // ↓ 设定卡片样式：正面or背面
        setCardStyle(showFace=false) {
            const sShowBack = `perspective(800px) rotateY(0deg)`;
            const sShowFace = `perspective(800px) rotateY(180deg)`; // ← 显示牌面 
            const {cardID, exposed} = this.card;
            // console.log("goFast =>", goFast); 
            const transform = (()=>{
                if (cardID === 'card_close'){
                    return sShowBack; // 始终显示背面
                }
                if (exposed || showFace) return sShowFace; 
                // ↓ 开启了动画就默认显示背面，稍后再转到正面  
                return this.animation ? sShowBack : sShowFace;
            })();
            // console.log(`exposed`, exposed, transform); 
            if (cardID !== 'card_close' && exposed && transform.includes('(0deg)')){ 
                debugger; 
            } 
            this.oCardStyle = {transform};
        },
    },
});
</script>

<style lang="scss" scoped src="../style/blackjack-card.scss"></style>

